import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ColumnButton, DivBackgroundOpacity } from "@utils/extra-style";

import { quoteStatusText, quoteStatusColor } from "@utils/constants";

const QuoteStatus = (props) => {
  const { t, status, isActive, statusOpacity } = props;
  const [newOpacity, setNewOpacity] = useState(1);
  useEffect(() => {
    if (!statusOpacity) {
      setNewOpacity(status !== 5 ? 1 : "0.2");
    }
  }, []);

  return (
    <>
      <DivBackgroundOpacity opacity={newOpacity}>
        <ColumnButton
          border={quoteStatusColor[status]}
          background={quoteStatusColor[status]}
          marginRight="10px"
        >
          <span>{t(quoteStatusText[status])}</span>
        </ColumnButton>
      </DivBackgroundOpacity>
    </>
  );
};

QuoteStatus.defaultProps = {
  isActive: true,
};

QuoteStatus.propTypes = {
  t: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  status: PropTypes.number.isRequired,
};

export default withTranslation()(QuoteStatus);
